import React from "react";
import CheckUnckeck from "../../../utility/templete/checkUnckeck";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
import FontAwesome from "../../../utility/fontAwesome/fontAwesome";
import { toNumeric } from "../../../utility/stringExtensions";
const BuyReseller = () => {
  return (
    <div>
      <table className="table text-justify">
        <thead className="thead-light">
          <tr>
            <th></th>
            <th></th>
            <th scope="col">نمایندگی یک 990 هزارتومان/دائمی</th>
            <th scope="col">نمایندگی دو 1/990 هزارتومان/دائمی</th>
            <th scope="col">نمایندگی سه 2/990 میلیون تومان/دائمی</th>
          </tr>
        </thead>
        <thead className="bg-info border-border-purple">
          <tr>
            <th scope="col" colSpan="5">
              <FontAwesome icon={faWrench} title="امکانات" />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">نمایندگی تلفن ابری</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ایجاد نامحدود کاربر</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">دارای تمام امکانات کاربری</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">خط اختصاصی رایگان برای هر کاربر ایجاد شده</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">خط عمومی رند از همه اپراتورها</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">خط خدماتی</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ارسال سیمکارتی</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">
              ورود کاربران از دامنه یا ساب دامنه اختصاصی نماینده
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">برند آرم و لوگوی اختصاصی</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">پکیج بندی مختلف پنلها</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">قیمت گذاری دلخواه روی پکیج ها</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه پیامک دلخواه روی پکیج ها</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">قیمت گذاری روی خطوط اختصاصی</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ثبت نام آنلاین کاربران</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ست کردن درگاه بانک ملت، پارسیان و زرین پال</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ست کردن درگاه بانک عمومی</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">واریز آنی هزینه پنل و سود پیامک</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">مدیریت تراکنش های کاربران</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">مدیریت تعرفه های ارسال كاربران</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">پشتيبانی تيكتی كاربران</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">پشتيبانی از سوی سایه بان</th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">ايجاد نامحدود نمايندگی</th>
            <th scope="col">
              <CheckUnckeck value={0} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
            <th scope="col">
              <CheckUnckeck value={1} />
            </th>
          </tr>
        </thead>
        <thead className="bg-info border-border-purple">
          <tr>
            <th></th>
            <th>تعرفه ها (برحسب تومان)</th>
            <th scope="col">سطح 1</th>
            <th scope="col">سطح 2</th>
            <th scope="col">سطح 3</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه اپراتور 50001 و 50009 همراه اول</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه اپراتور 50002 و 50005 همراه اول</th>
            <th scope="col">90</th>
            <th scope="col">81</th>
            <th scope="col">73</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه اپراتور 50004</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه اپراتور 1000</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه پیامک اپراتور 2000</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه پیامک اپراتور 3000</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه هر پیامک از اپراتور 021و026</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        {/* <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه هر پیامک اپراتور ارسال sim</th>
            <th scope="col">58/5</th>
            <th scope="col">53/1</th>
            <th scope="col">47/7</th>
          </tr>
        </thead> */}
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه هر پیامک از دکل bts</th>
            <th scope="col">100</th>
            <th scope="col">90</th>
            <th scope="col">80</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">تعرفه هر ثانیه پیام صوتی</th>
            <th scope="col">93</th>
            <th scope="col">85</th>
            <th scope="col">76</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">هزینه تمدید سالانه</th>
            <th scope="col">رایگان</th>
            <th scope="col">رایگان</th>
            <th scope="col">رایگان</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">قیمت سامانه</th>
            <th scope="col">{toNumeric(990000)}</th>
            <th scope="col">{toNumeric(1990000)}</th>
            <th scope="col">{toNumeric(2990000)}</th>
          </tr>
        </thead>
        <thead className="thead-light">
          <tr>
            <th scope="col" colSpan="2">
              همین الان ثبت نام کنید!
            </th>
            <th scope="col" colSpan="3">
              <a
                href="http://sms.sayyehban.ir/register.jspd"
                className="btn btn-info"
                style={{ width: "100%" }}
              >
                ثبت نام آنلاین
              </a>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default BuyReseller;
